import "./ChapelCard.css"

const ChapelCard = ({ title, events }) => {
  return (
    <div className="chapel-card">
      <img className="divider-chapel" src="./assets/5.png" alt="separator"/>
      <h4>{title}</h4>
      {events.map((event, index) => (
        <p key={index}>{event}</p>
      ))}
    </div>
  );
};

export default ChapelCard;